import { render, staticRenderFns } from "./DBC_modal.vue?vue&type=template&id=7b2c829a"
import script from "./DBC_modal.vue?vue&type=script&lang=js"
export * from "./DBC_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports